import { render } from "./CampaignMedia.vue?vue&type=template&id=5cf4bc77&scoped=true"
import script from "./CampaignMedia.vue?vue&type=script&lang=js"
export * from "./CampaignMedia.vue?vue&type=script&lang=js"

import "./CampaignMedia.vue?vue&type=style&index=0&id=5cf4bc77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf4bc77"]])

export default __exports__